import React from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import cx from "classnames";
import styles from "./style.module.scss";
import {
  MDBBreadcrumb,
  MDBBreadcrumbItem,
  MDBContainer,
  MDBRow,
  MDBCol
} from "mdbreact";
import { breadCrumb } from "~/utils/breadcrumb";

class MyBreadcrumb extends React.PureComponent {
  render() {
    const {
      location: { pathname },
      className,
      type,
      listItem,
      hospitalSelected
    } = this.props;

    const list = () => {
      if (type === "text") {
        return listItem;
      } else {
        return breadCrumb(pathname, hospitalSelected).filter(item => item);
      }
    };

    return (
      <div className={styles.bg_breakcum}>
        <MDBContainer>
          <MDBRow>
            <MDBCol size={12}>
              <div className={cx(styles.wrap_mdbreadcrumb, styles[className])}>
                <MDBBreadcrumb>
                  {list().map((item, index) => {
                    const isActivedCls = item.isActive ? styles.active : "";
                    return (
                      <MDBBreadcrumbItem
                        key={`bc${index}`}
                        className={isActivedCls}
                      >
                        {item.url ? (
                          <Link to={item.url}>{item.title}</Link>
                        ) : (
                          item.title
                        )}
                      </MDBBreadcrumbItem>
                    );
                  })}
                </MDBBreadcrumb>
                <div className={styles.head_item}>
                  {/* {lastElement && lastElement.title} */}
                </div>
              </div>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    hospitalSelected: state.totalData.hospitalSelected
  };
};

export default connect(mapStateToProps, null)(withRouter(MyBreadcrumb));
